import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Menu, Close } from '@material-ui/icons';
import DovemedLogo from "../../../assets/dovemed_logo.svg";
import { useAuth } from '../../../context/auth';
import { NotificationPopper } from "../NotificationPopper/NotificationPopper";
import { Drawer } from '../../Drawer';
import {
  ToolbarMobile,
  Logo,
  StyledIconButton,
  StyledLink
} from './MobileToolbar.styles';

export function MobileToolbar() {
  const location = useLocation();
  const { user, authToken } = useAuth();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const handleClose = () => {
    setDrawerOpen(!isDrawerOpen);
  }
  return (
    <>
      <ToolbarMobile>
        {user ?
          <>
            <StyledIconButton onClick={() => setDrawerOpen(!isDrawerOpen)}>
              {isDrawerOpen ? <Close /> : <Menu /> }
            </StyledIconButton>
            <Link onClick={() => setDrawerOpen(false)} to={`${process.env.REACT_APP_INTERNAL_URL}`}>
              <Logo src={DovemedLogo} alt="logo" />
            </Link>
            <NotificationPopper user={user} authToken={authToken} />
          </>
          :
          <>
            <StyledIconButton onClick={() => setDrawerOpen(!isDrawerOpen)}>
              {isDrawerOpen ? <Close /> : <Menu /> }
            </StyledIconButton>
            <Link onClick={() => setDrawerOpen(false)} to={`${process.env.REACT_APP_INTERNAL_URL}`}>
              <Logo src={DovemedLogo} alt="logo" />
            </Link>
            <StyledLink to={{
              pathname: location.pathname,
              state: { openLogin: true }
            }}>Login</StyledLink>
          </>
        }
      </ToolbarMobile>
      {isDrawerOpen && <Drawer user={user} close={handleClose} />}
    </>
  )
}
